import { Col, Row } from "antd";
import React from "react";
import AdnCard from "../common/adnCard/AdnCard";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnTable from "../common/adnTable/AdnTable";

const MessageStatisticListForm = ({
  title,
  loading,
  columns,
  historyColumns,
  statistics,
  totalRecords,
  currentPage,
  handleChangePage,
  handleChangeOrder,
}) => {
  return (
    <>
      <AdnPageTitle title={title} />
      <AdnCard loading={loading}>
        <Row>
          <Col span={24}>
            <AdnTable
              columns={columns}
              expandable={(record) => (
                <AdnTable
                  columns={historyColumns}
                  data={record.messageHistories}
                />
              )}
              data={statistics}
              totalRecords={totalRecords}
              currentPage={currentPage}
              handleChangePage={handleChangePage}
              handleChange={handleChangeOrder}
            />
          </Col>
        </Row>
      </AdnCard>
    </>
  );
};

export default MessageStatisticListForm;
